import styles from './Home.module.scss';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import SearchArea from '@/components/help/common/SearchArea';
import RecommendKeyword from '@/components/help/common/RecommendKeyword';
import Question from './Question';
import HelpCategory from './HelpCategory';
import InfoBanner from './InfoBanner';
import InquiryBanner from './InquiryBanner';

const HelpHome = () => {
  const {isMobile} = useHelpContext();

  return (
    <div className={styles.HomeWrapper}>
      <SearchArea />
      <RecommendKeyword />
      <Question />
      <HelpCategory />
      {!isMobile && <InfoBanner />}
      <InquiryBanner />
    </div>
  );
};

export default HelpHome;
